export default __webpack_public_path__ + "static/media/airstrapz-bpk-banner-3.6ee1b0cf.jpg";